<template>
  <div class="news" v-if="news">
    <div class="columns is-variable is-2 is-multiline is-mobile">
      <div class="column is-one-quarter-desktop is-half-tablet is-full-mobile">
        <CardLink size="medium" :data="news[11]" type="news" />
        <CardLink size="medium" :data="news[12]" type="news" />
        <CardLink size="small" :data="news[13]" type="news" />
        <CardLink size="medium" :data="news[14]" type="news" />
        <CardLink size="small" :data="news[15]" type="news" />
        <CardLink size="small" :data="news[16]" type="news" />
      </div>
      <div class="column is-one-quarter-desktop is-half-tablet is-full-mobile">
        <CardLink size="medium" :data="news[17]" type="news" />
        <CardLink size="medium" :data="news[18]" type="news" />
        <CardLink size="small" :data="news[19]" type="news" />
        <CardLink size="medium" :data="news[20]" type="news" />
        <CardLink size="small" :data="news[21]" type="news" />
        <CardLink size="small" :data="news[22]" type="news" />
      </div>
      <div class="column is-half-desktop is-full-tablet is-full-mobile">
        <CardLink size="large" :data="news[0]" type="news" />
        <div class="columns is-variable is-2 is-multiline is-mobile">
          <div class="column is-half-desktop is-full-tablet is-full-mobile">
            <CardLink size="small" :data="news[1]" type="news" />
            <CardLink size="small" :data="news[2]" type="news" />
            <CardLink size="medium" :data="news[3]" type="news" />
            <CardLink size="small" :data="news[4]" type="news" />
            <CardLink size="small" :data="news[5]" type="news" />
          </div>
          <div class="column is-half-desktop is-full-tablet is-full-mobile">
            <CardLink size="small" :data="news[6]" type="news" />
            <CardLink size="small" :data="news[7]" type="news" />
            <CardLink size="medium" :data="news[8]" type="news" />
            <CardLink size="small" :data="news[9]" type="news" />
            <CardLink size="small" :data="news[10]" type="news" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CardLink from "../components/CardLink";
export default {
  components: {CardLink },
  async beforeCreate() {
    this.news = await this.$news.GetLatest();
  },
  data() {
    return {
      news: undefined,
      columnCount: 0,
    }
  }
}
</script>
